<app-breadcrumbs [title]="'MENU.ADMINISTRATION.REGISTRATIONS_REQUESTS'" [first]="'MENU.ADMINISTRATION.REGISTRATIONS_REQUESTS'"></app-breadcrumbs>

<div class="row">
    <dx-tab-panel #tabPanel 
                class="col-12"
                [dataSource]="tabs" 
                [selectedIndex]="0" 
                [loop]="false" 
                [animationEnabled]="true" 
                [swipeEnabled]="true" 
                (onSelectionChanged)="navigateTo($event)">
        <div *dxTemplate="let tab of 'title'">
            <span>{{ 'REGISTRATIONS.STATES.' + tab | translate }}</span>
        </div>
        <div *dxTemplate="let tab of 'item'">
            <dx-data-grid #table [dataSource]="dataSources[tab]" [rowAlternationEnabled]="true" [showBorders]="true" [showRowLines]="true" [showColumnLines]="true" [allowColumnResizing]="true" columnResizingMode="nextColumn"[columnHidingEnabled]="true">
                <dxo-remote-operations [filtering]="true" [paging]="true" [sorting]="true"></dxo-remote-operations>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-paging [pageSize]="15"></dxo-paging>
                <dxo-pager [showInfo]="true"></dxo-pager>
                <dxo-state-storing [enabled]="true" [type]="'custom'" [customLoad]="loadGridState" [customSave]="saveGridState"></dxo-state-storing>
    
                <ng-container *ngIf="tab == [RegistrationsRequestsStatus.APPROVED]">
                    <dxi-column dataField="businessPartner.name" dataType="string" [allowFiltering]="false" [allowSorting]="false" [caption]="'SHARED.BUSINESS_PARTNER' | translate"></dxi-column>
                </ng-container>
                <ng-container *ngIf="tab == [RegistrationsRequestsStatus.DECLINED]">
                    <dxi-column dataField="note" dataType="string" [allowFiltering]="false" [allowSorting]="false" [caption]="'SHARED.NOTE' | translate"></dxi-column>
                </ng-container>
                <dxi-column dataField="email" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.EMAIL' | translate"></dxi-column>
                <dxi-column dataField="suggestionName" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'REGISTRATIONS.SUGGESTION_NAME' | translate"></dxi-column>
                <dxi-column dataField="idNumber" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.ID' | translate"></dxi-column>
                <dxi-column dataField="name" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.FIRST_NAME' | translate"></dxi-column>
                <ng-container *ngIf="tab == [RegistrationsRequestsStatus.APPROVED]">
                    <dxi-column dataField="relatedEntity" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.RELATED_ENTITY' | translate"></dxi-column>
                </ng-container>
                <dxi-column dataField="telephone" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.PHONE_NUMBER' | translate"></dxi-column>
                
                <ng-container *ngIf="tab == [RegistrationsRequestsStatus.NEW]">
                    <dxi-column cellTemplate="actionsTemplate" [fixed]="true" fixedPosition="right"[allowFiltering]="false" [allowSorting]="false" [caption]="''" [cssClass]="'actions'"></dxi-column>
                </ng-container>
    
                <div *dxTemplate="let template of 'actionsTemplate'" class="text-right">
                    <span class="table-icon ti-check" [matTooltip]="'REGISTRATIONS.BUTTONS.APPROVE' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="approveRegistrationData = template.data"></span>
                    <span class="table-icon text-danger ti-close mr-2" [matTooltip]="'REGISTRATIONS.BUTTONS.DENY' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="declineRegistrationData = template.data"></span>
                </div>
    
            </dx-data-grid>
        </div>
    </dx-tab-panel>
</div>
<dx-popup width="500px" height="230px" maxWidth="90%" [(visible)]="approveRegistrationData" [title]="'REGISTRATIONS.CHOOSE_PARTNER' | translate" (onHiding)="approveRegistrationData = null; selectedBusinessPartner = null">
    <div class="dx-fieldset">
        <div class="dx-field">
            <div class="dx-field-label">{{ 'SHARED.BUSINESS_PARTNER' | translate}}</div>
            <div class="dx-field-value">
                <dx-tag-box [dataSource]="businessPartners" displayExpr="name" [searchEnabled]="true" [(value)]="selectedBusinessPartner"></dx-tag-box>
            </div>
        </div>
    </div>
    <hr class="wsh-hr">
    <div class="dx-popup-footer">
        <div class="row col-sm-8 offset-sm-2">
            <div class="col-sm">
                <dx-button class="navbar-button btn-block" [height]="32" stylingMode="contained" icon="save" [text]="'DEV-EXTREME.OK' | translate" type="success" [disabled]="!selectedBusinessPartner || loadingService.unfinishedRequests" (onClick)="approveRegistration()"></dx-button>
            </div>
            <div class="col-sm">
                <dx-button class="navbar-button btn-block" [height]="32" stylingMode="outlined" icon="close" [text]="'SHARED.CLOSE' | translate" type="normal" [disabled]="loadingService.unfinishedRequests" (onClick)="approveRegistrationData = null; selectedBusinessPartner = null"></dx-button>
            </div>
        </div>
    </div>
</dx-popup>

<dx-popup width="500px" height="230px" maxWidth="90%" [(visible)]="declineRegistrationData" [title]="'REGISTRATIONS.REJECTING_REASON' | translate" (onHiding)="declineRegistrationData = null; note = null">
    <div class="dx-fieldset">
        <div class="dx-field">
            <div class="dx-field-label">{{ 'SHARED.REASON' | translate}}</div>
            <div class="dx-field-value">
                <dx-text-box valueChangeEvent="keyup" [(value)]="note"></dx-text-box>
            </div>
        </div>
    </div>
    <hr class="wsh-hr">
    <div class="dx-popup-footer">
        <div class="row col-sm-8 offset-sm-2">
            <div class="col-sm">
                <dx-button class="navbar-button btn-block" [height]="32" stylingMode="contained" icon="save" [text]="'DEV-EXTREME.OK' | translate" type="success" [disabled]="loadingService.unfinishedRequests" (onClick)="declineRegistration()"></dx-button>
            </div>
            <div class="col-sm">
                <dx-button class="navbar-button btn-block" [height]="32" stylingMode="outlined" icon="close" [text]="'SHARED.CLOSE' | translate" type="normal" [disabled]="loadingService.unfinishedRequests" (onClick)="declineRegistrationData = null; note = null"></dx-button>
            </div>
        </div>
    </div>
</dx-popup>